import { VisuallyHidden } from '@react-aria/visually-hidden';
import { useIntl } from 'react-intl';

import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAuth } from '@/context/auth/AuthProvider';
import { CalmAuthMethods } from '@/utils/privacyCookies';

import messages from './messages';
import { Icon, Wrapper } from './styles';
import { AppleAuthButtonProps, AppleButtonProps } from './types';

const AppleButton = ({ hideMessage = false, onClick }: AppleButtonProps) => {
	const { formatMessage } = useIntl();
	const { authPrompt } = useAuthPrompt();

	const getButtonCta = () => {
		return authPrompt === 'login'
			? formatMessage(messages.appleSignInCta)
			: formatMessage(messages.appleContinueCta);
	};

	const buttonCta = getButtonCta();
	const bgColor = 'white';
	const textColor = 'black';
	const borderColor = 'gray3';

	return (
		<Wrapper
			backgroundColor={bgColor}
			contentAlignment="center"
			onPress={onClick}
			data-testid="apple-button"
			role="link"
			$noPadding={hideMessage}
			textColor={textColor}
			borderColor={borderColor}
		>
			<Icon $noMargin={hideMessage} $iconColor={textColor} />
			{hideMessage ? <VisuallyHidden>{buttonCta}</VisuallyHidden> : buttonCta}
		</Wrapper>
	);
};

const AppleAuthButtonBrowser = (props: AppleAuthButtonProps) => {
	const { hideMessage, onAuthSuccess, marketingOptIn } = props;

	const { authenticate } = useAuth();

	const onClick = async (): Promise<void> => {
		authenticate({ authMethod: CalmAuthMethods.Apple, marketingOptIn, onAuthSuccess });
	};

	return <AppleButton hideMessage={hideMessage} onClick={onClick} />;
};

function AppleAuthButton(props: AppleAuthButtonProps) {
	return <AppleAuthButtonBrowser {...props} />;
}

export default AppleAuthButton;
